// hooks/useCashTransactions.ts
import { useCallback, useState } from "react";
import { message } from "antd";
import { useTranslation } from "react-i18next";
import {
    CashTransaction,
    CashTransactionSearchParams
} from "../../../types/cashTransactionTypes";
import { getAllTransactions } from "../../../services/cashTransactionService";

export const useCashTransactions = () => {
    const { t } = useTranslation();

    const [transactions, setTransactions] = useState<CashTransaction[]>([]);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 50,
        total: 0,
    });

    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const fetchTransactions = useCallback(
        async (params: CashTransactionSearchParams = {}) => {
            setLoading(true);
            try {
                const result = await getAllTransactions(params);

                setTransactions(result.data || []);
                setPagination(result.pagination || pagination);
                setError(null);
            } catch (err) {
                console.error(err);
                setError(t("cashbox.errors.failed_to_fetch_transactions"));
                // message.error(t("cashbox.errors.failed_to_fetch_transactions"));
            } finally {
                setLoading(false);
            }
        },
        [t]
    );



    return {
        transactions,
        pagination,
        loading,
        error,
        fetchTransactions,
    };
};

export default useCashTransactions;